import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { DataService_BellScheduleSetup } from "./shared/data.service";
import { UserService } from "../../../shared";

//INSERT POPUP IMPORTS
import { SchoolAddBellScheduleComponent } from "./school-add-bell-schedule/school-add-bell-schedule.component";
import { SchoolEditBellScheduleComponent } from "./school-edit-bell-schedule/school-edit-bell-schedule.component";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";

@Component({
	selector: "caass-bell-schedule-setup",
	templateUrl: "./bell-schedule-setup.component.html",
	styleUrls: ["./bell-schedule-setup.component.css"],
})
export class BellScheduleSetupComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private userService: UserService,
		private BellScheduleSetupService: DataService_BellScheduleSetup,
		private dialogService: DialogService,
		private schoolService: SchoolService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		// this.loadSchoolist();
		// this.loadBellSchedule();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	subscription: any;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedBellSchedule: any;
	lstBellSchedule: any = [];

	//Filter lists
	lstActive: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "BellScheduleDesc", header: "Name" },
		{ field: "Active", header: "Active" },
	];

	SchoolID: any;
	lstSchool: any = [];

	///////////////

	ToggleText: any = "Deactivate Bell Schedule";

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////
	private loadSchoolist() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;
				this.SchoolID = this.lstSchool[0].SchoolID;

				this.loadBellSchedule();
			},
			(error) => {}
		);
	}

	loadBellSchedule() {
		this.loading = true;

		var result = this.BellScheduleSetupService.LoadBellSchedule(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstBellSchedule = response;

				for (var i = 0; i < this.lstBellSchedule.length; i++) {
					var next = this.lstBellSchedule[i];

					next.Active = next.Active == 1 ? "Active" : "Inactive";
				}

				//Load Data Filter Lists
				this.lstActive = Array.from(new Set(this.lstBellSchedule.map((item: any) => item.Active))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadBellSchedule();
	}

	//Custom Button Methods
	onAddBellSchedule() {
		this.errorMessage = "";

		var ref = this.dialogService.open(SchoolAddBellScheduleComponent, {
			header: "Add Bell Schedule",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SchoolID: this.SchoolID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadBellSchedule();
			}
		});
	}

	onEditBellSchedule() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedBellSchedule == undefined) {
			this.errorMessage = "Select a Bell Schedule to edit";
			return;
		}

		var ref = this.dialogService.open(SchoolEditBellScheduleComponent, {
			header: "Edit Bell Schedule",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SchoolID: this.SchoolID,
				BellScheduleID: this.SelectedBellSchedule.BellScheduleID,
				BellScheduleDesc: this.SelectedBellSchedule.BellScheduleDesc,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadBellSchedule();
			}
		});
	}

	onToggleBellSchedule() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedBellSchedule == undefined) {
			this.errorMessage = "Select a Bell Schedule to toggle";
			return;
		}

		var changeTo = this.SelectedBellSchedule.Active == "Active" ? 0 : 1;

		//Call SP
		var result = this.BellScheduleSetupService.BellScheduleToggle(this.SelectedBellSchedule.BellScheduleID, changeTo);
		result.subscribe(
			(response) => {
				this.loadBellSchedule();
				this.onRowUnselect(null);
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onSchoolChange(val) {
		this.SchoolID = val;

		this.loadBellSchedule();
	}
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedBellSchedule = val.data;

		this.ToggleText = "Deactivate Bell Schedule";
		if (this.SelectedBellSchedule.Active == "Inactive") {
			this.ToggleText = "Activate Bell Schedule";
		}
	}
	onRowUnselect(val) {
		this.SelectedBellSchedule = null;
		this.ToggleText = "Deactivate Bell Schedule";
	}
	onRowDblClick(BellSchedule) {
		this.SelectedBellSchedule = BellSchedule;

		this.ToggleText = "Deactivate Bell Schedule";
		if (this.SelectedBellSchedule.Active == "Inactive") {
			this.ToggleText = "Activate Bell Schedule";
		}

		this.onEditBellSchedule();
	}
	////////////////////////////////////////////
}
